import React from 'react';

const AUTHContext = React.createContext();

export default AUTHContext;
